<template>
  <div>
    <ats-web-seamless-header
      :api-url="apiUrl"
      :api-key="apiKey"
      :tenant-id="tenantId"
      :default-language="defaultLanguage"
      data-test="seamless-header"
      @atsLogoClick="handleLogoClick"
      @atsLanguageClick="handleLanguageToggle"
    />
  </div>
</template>

<script lang="ts">
import { useRoute } from "vue-router";
import { ApiKey } from "~~/types";

import { useLanguageStore } from "~/stores/language";
import { Language, Page } from "~/utils/constants";

type AtsLanguageClickEvent = CustomEvent<{ id: string; value: string; isFrench: boolean }[]>;

export default {
  setup() {
    const languageStore = useLanguageStore();
    const route = useRoute();
    const config = useRuntimeConfig();

    return {
      languageStore,
      route,
      config,
    };
  },

  computed: {
    apiUrl() {
      return this.config.public.apiUrl;
    },

    apiKey() {
      return this.config.public[ApiKey.AUTOSYNC];
    },

    tenantId() {
      return this.config.public.motocommerce.tenantId;
    },

    defaultLanguage() {
      return this.languageStore.language;
    },
  },

  methods: {
    async handleLogoClick(): Promise<void> {
      await navigateTo(Page.SEARCH);
    },

    async handleLanguageToggle(event: AtsLanguageClickEvent): Promise<void> {
      const { isFrench } = event.detail[0];
      await this.languageStore.setCurrentLanguage(isFrench ? Language.FR : Language.EN);
    },
  },
};
</script>
